import request from '@/utils/request'

// 获取日统计数据
export function getGateList(data) {
  return request.get('/statistical/dayReport')
}

// 获取日统计数据
export function getEquipmentList(data) {
  return request.get('/statistical/equipmentState')
}

// 获取预约列表
export function getManOrderList(data) {
  const { start, end, ...params } = data
  return request.get('/personOrder/list', {
    params: {
      ...params,
      startDate: start,
      endDate: end,
      name: '',
      gate: 9,
      status: 9
    }
  })
}

// 获取预约列表
export function getTruckOrderList(data) {
  const { start, end, ...params } = data
  return request.get('/truckOrder/list', {
    params: {
      ...params,
      startDate: start,
      endDate: end,
      plateNumber: '',
      status: 9
    }
  })
}

// 获取访问列表
export function getManAccessList(data) {
  const { start, end, ...params } = data
  return request.get('/personAccess/list', {
    params: {
      ...params,
      startDate: start,
      endDate: end,
      name: '',
      gate: 9,
      type: 9
    }
  })
}

// 获取访问列表
export function getTruckAccessList(data) {
  const { start, end, ...params } = data
  return request.get('/truckAccess/list', {
    params: {
      ...params,
      startDate: start,
      endDate: end,
      truckType: '',
      plateNumber: '',
    }
  })
}

// 获取过磅列表
export function getWeighBridgeList(data) {
  const { start, end, ...params } = data
  return request.post('/weighbridge/list', {
    ...params,
    startDate: start,
    endDate: end,
    type: 9,
    status: 9,
    plateNumber: '',
  }).then(({ data }) => {
    const { msg, data: queryData, code } = data
    const { records, total } = queryData
    return { data: { msg, data: { items: records, total }, code } }
  })
}

// 获取灌料列表
export function getMaterialCheckList(data) {
  const { start, end, ...params } = data
  return request.get('/dualCheck/list', {
    params: {
      ...params,
      startDate: start,
      endDate: end,
      status: 9,
      plateNumber: '',
    }
  })
}